import { Box, useTheme } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

export const ScrollbarWrapper = ({ children }: Props) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        overflowX: 'auto',
        maxWidth: '100%',
        '&::-webkit-scrollbar': {
          height: '8px',
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: `${theme.scrollbar?.thumb}`,
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: `${theme.scrollbar?.thumbHover}`,
        },
      }}
    >
      {children}
    </Box>
  );
};
